import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';

class Component extends BaseComponent {
    render({ card_id }) {
        return (
            <tarot-reading-deck-card card_id={card_id} onmousedown={this.pick} />
        );
    }

    pick = () => {
        if (this.props.card_id == 'picked' || this.props.card_id === null) {
            return;
        }

        if (this.props.upsell && this.props.upsell_upc) {
            this.props.tarotInit(this.props.upsell_upc);
            this.props.tarotUpsell();
        }

        if (this.props.completed) {
            if (this.props.upc == 'yes-or-no-tarot-redux' && this.props.view == 'view-1') {
                document.querySelector('button[data-action="Click-Shuffle-Cards-Button"]').click();
                return;
            }

            if (!this.props.upsell) {
                this.props.tarotFetch();
                return;
            }
        }

        this.props.tarotPicked(this.props.card_id);
        this.props.deckSpread(this.props.card_id);
    }
}

const mapStateToProps = (state) => ({
    completed: state['tarot-reading'].cards.length === state['tarot-reading'].positions.length,
    upsell_upc: state.product && state.product.teeup && state.product.teeup.upsell_upc,
});

const mapDispatchToProps = (dispatch) => ({
    tarotInit: (upc) => dispatch({ type: 'tarot-reading:init', payload: {upc: upc} }),
    tarotUpsell: () => dispatch({ type: 'tarot-reading:upsell' }),
    tarotFetch: () => dispatch({ type: 'tarot-reading:fetch' }),
    tarotPicked: (card_id) => dispatch({ type: 'tarot-reading:picked', payload: { card: card_id, source: 'Deck'} }),
    deckSpread: (card_id) => dispatch({ type: 'deck:spread', payload: card_id }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
